module.exports = __webpack_public_path__ + "static/img/scmbanner.6a07784.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/scmbanner.png
// module id = ZCw3
// module chunks = 1